<div class="container">
      <nav class="navbar navbar-expand-lg ">
        <div style="width: 100%;display: flex;" class="col-12">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="col-12 navbar-nav mx-auto mb-2 mb-lg-0 fw-bold" style="width: 100%;">
                <li class="col-3 nav-item dropdown has-megamenu">
                  <div class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
                  aria-expanded="false" (click)="getTotalMenu('','')">
                  <label class="form-label">Select Model</label>
                  <input type="text" class="form-select h-48 search-form-control product-search bannerApplication" [(ngModel)]="filterModel" (input)="filtermodel()" (blur)="getblurmodels()"
                    placeholder="Choose the model to buy"  id="applicationFilter" #applicationFilter />
                </div>
                  <div class="dropdown-menu megamenu bannerApplication ">
                    <div class=" px-0">
                      <div class="d-flex align-items-start leftslide">
                        <div class="nav flex-column nav-pills me-3 mega-vertical-tab" id="v-pills-tab" role="tablist"
                          aria-orientation="vertical">
                          <ul class="citilistmodels">
                            <li *ngIf="filteredmodels?.length === 0" >No Data Found</li>
                            <li (mouseenter)="onSubMenuClick('SCVPickups',item.sub_cat_id)" *ngFor="let item of filteredmodels; let i=index" ><a
                                class="dropdown-item"
                                class="megatab active" id="{{'tab' + i}}" data-bs-toggle="pill" data-bs-target="#t1"
                                role="tab" aria-controls="#t1" aria-selected="true">{{item.sub_cat_name}}<img
                                  alt="caret-right-black" *ngIf="subMenuType == item.sub_cat_id"
                                  [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy"
                                  alt="caret-right-black" /></a></li>
                          </ul>
                        </div>
                        <div class="tab-content mega-vertical-content" id="v-pills-tabContent"  [ngStyle]="{ 'overflow-y': subMenu?.length  > 5 ? 'scroll' : '' }" style="height: 318px;">
                          <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                            <div class="container-fluid">
                              <div class="row g-3 row-cols-5">
                                <div *ngIf="subMenu?.length === 0" >No Data Found</div>
                                <div class="col" *ngFor="let item of subMenu">
                                  <a  class="menu-option" (click)="onMenuclick(item)">
                                    <div class="menu-img">
                                      <img class="img-fluid subcatimages" loading="lazy" [src]="getdefault(item.name)"  alt="">
                                    </div>
                                    <div class="menu-title text-center">
                                      {{item.name}}
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="col-3 nav-item dropdown has-megamenu">

                  <div class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown"
                  aria-expanded="false" (click)="getBudget()">
                    <label class="form-label">Select Budget</label>
                <input type="text" class="form-select h-48 search-form-control product-search bannerApplication"
                readonly  [(ngModel)]="filterBudget" placeholder="Choose Budget Range" id="applicationFilterbudget" #applicationFilterbudget />
                  </div>
                  <div class="dropdown-menu megamenu" role="menu" aria-labelledby="navbarDropdown" (click)="stopPropagation($event)" >
                    <div class="px-0">
                      <div class="d-flex justify-content-center">

                       <div class="row col-10 mt-1">
                        <div class="d-flex justify-content-center">
                        <!-- <div class="result">
                          100 Result
                        </div> -->
                      </div>
                        <div>
                          <ngx-slider [(value)]="value" [(highValue)]="highValue" [options]="options" (userChangeEnd)="onSliderChange($event)"></ngx-slider>
                        </div>
                        <div class="row col-12">
                        <div class=" col-6">
                          <label class="filter-label">Min Price</label>
                          <div class="minvalue">
                          <input type="text" (keypress)="onlyNumberKey($event)"  [value]="value" (input)="onMinPriceChange($event)" class="form-control minvalue" maxlength="10" minlength="1" />
                        </div>
                        </div>
                        <div class="col-6">
                          <label class="filter-label">Max Price</label>
                          <div class="minvalue">
                          <input type="text" (keypress)="onlyNumberKey($event)" [value]="highValue" (input)="onMaxPriceChange($event)" class="form-control minvalue " maxlength="10" minlength="1" />
                        </div>
                        </div>
                      </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="col-3 nav-item dropdown has-megamenu">

                  <div class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
                  aria-expanded="false">
                    <label class="form-label">Select State</label>
                    <input type="text" class="form-select h-48 search-form-control product-search bannerApplication" [(ngModel)]="filterText"
                    (input)="filterstates()" (blur)="getblurstate()"
                    placeholder="Choose State"  id="applicationFilter" #applicationFilter />
                    <div class="dropdown-menu megamenu  bannerApplication  cityDiv">
                      <div class="px-0">
                        <ul class="citilist list-group">
                          <li *ngIf="filteredstates?.length === 0" class="list-group-item">No Data Found</li>
                          <li class="list-group-item list-group-item-action" *ngFor="let elemet of filteredstates" (click)="changestates(elemet)">
                            {{ elemet}}
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>

                </li>
                <li class="col-3 nav-item dropdown has-megamenu">
                    <div class="searchdesk">
                        <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" (click)="getFilterdata(0)">Search</button>
                      </div>
                  </li>
              </ul>

          </div>

        </div>
      </nav>
      <div class="d-md-none row col-12">
        <span class="text-secondary mb-2">Search Vehicle</span>
        <div class="col-8">
            <button class="navbar-toggler text-secondary searchtbnmodel d-md-none btn  btn-lg  w-100" type="button" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight1" aria-controls="offcanvasRight1" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            .Model &nbsp;&nbsp; .Budget &nbsp;&nbsp; .State
          </button>
        </div>
        <div class="col-4">
            <button class="navbar-toggler searchtbnm d-md-none btn btn-primary btn-lg btn-grad-primary btn-brand w-100" type="button" (click)="getFilterdata(0)" >
            Search
          </button>
        </div>


</div>

<div class="col-12" >
<div class="global_inventory">
    <div class="row mb-4">
    <div class="col-6 col-lg-6 col-md-6 col-sm-6">
        <h1 class="gl">Global Inventory <span *ngIf="!isMobile">(Dealers declaration)</span></h1>
    </div>
    <div class="col-6 d-flex">
      <div class="ms-auto short-by ps-3 pe-3 position-relative d-none d-md-flex">
        Sort by

        <div class="sort-filter ps-4 position-relative active">
          <span class="">Price : </span>
          <select class="form-select" (change)="onFilterChange($event,'')" [(ngModel)]="sortingType">
            <option [value]="item" *ngFor="let item of sortList">{{item}}</option>
          </select>
        </div>
      </div>
        <div class="short-by ps-3 pe-3 position-relative  d-md-flex">
          <div class="d-flex align-items-center">
            <h3 class="cerfiedlabel">Certified</h3>
            <label class="switch">
              <input type="checkbox" (ngModelChange)="onToggle($event)" [(ngModel)]="isCertified">
              <span class="slider round"></span>
            </label>
          </div>
          </div>
    </div>

    </div>
</div>
<div class="row parknsell">
    <div class="col-12 col-lg-4 btndiv col-xs-12 col-sm-12">
        <button class="btn   rounded" [ngClass]=" selectedButton === 'mostViewed' ? 'btn1':'btn2'" (click)="mostViewcontent('mostViewed')">MOST VIEWED</button>
        <button class="btn  ms-3  rounded" [ngClass]=" selectedButton === 'recentlyAdded' ? 'btn1':'btn2'"  (click)="recentaddedContent('recentlyAdded')">RECENTLY ADDED</button>
    </div>


</div>
<div class="productlist mt-3" *ngIf="mostViewData">
  <div class="row">
    <ng-container *ngIf="ParknSell?.length == 0 && !productLoaded ;else productTemplate">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      *ngFor="let item of skeletonService.generateFake(4);let i = index;">
      <div class="poduct-item">
        <div class="img-wrapper" style="display: block;z-index: 0;">
          <ngx-skeleton height="230px"></ngx-skeleton>
        </div>
        <div class="cv-name text-ellipsis">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
        <div class="price">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
        <div class="rating">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
      </div>
    </div>
      </ng-container>
      <ng-template #productTemplate>
        <ng-container *ngIf="ParknSell?.length !== 0 && productLoaded ">
    <div class="col-lg-3 col-md-12 col-sm-12 carddiv" *ngFor="let element of ParknSell">
      <div class="card">
        <img (click)="redirect(element.id)" [src]="getiscover(element?.vehicle_documents)"  class="card-img-top mainimg" alt="Vehicle Image">
        <div class="d-flex align-items-center tagf">
            <span class="badge bg-primary"><img class="eye" [src]='environment1 + "assets/images/eye.png"' alt=""> {{element?.view_count}} Views </span>
            <div class="like ms-auto d-none">
              <button style="width: 24px; height: 24px; border: none;background-color: transparent;">
                <span >
                  <img style="width: 24px; height: 24px;" [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                </span>
              </button>
            </div>
          </div>
          <div *ngIf="element.vehicle_certificate_type == 'Certified'">
            <img class="tataoklogobottom" [src]='environment1 + "assets/images/tata-ok.png"' alt="">
            <span class="text-white tataoklogobottomspan">Refurbished</span>
          </div>
        <div class="card-body">
          <div class="card-title text-ellipsis">
            <a  [title]="element?.model">{{element.model}}</a></div>
            <div class="card-data">
            <div class="d-flex col-12 text-left d1 aligndiv" >
              <p class="col-4">State</p>
              <p class="col-4">District</p>
                <p class="col-4">Fuel Type</p>
            </div>
            <div class="d-flex col-12 text-left d2 aligndiv d3" >
                <p class="col-4 district pe-1">{{element?.state}}</p>
                <p class="col-4 district">{{element?.district ? (element?.district  | titlecase) : ''}}</p>
                <p class="col-4">{{element.fuel_type}}</p>
            </div>
            <div class="d-flex col-12 text-left d1 aligndiv mt-2" >
                <p class="col-4">KMs</p>
                <p class="col-4">Owner</p>
                <p class="col-4">Year</p>
            </div>

            <div class="d-flex col-12 text-left d2 aligndiv" >
                <p class="col-4">{{element.odometer ? (element.odometer |  number:'1.0-0') : ''}}</p>
                <p class="col-4">{{getFirstPartOfOwners(element.no_of_owners)}}</p>
                <p class="col-4">{{element.year_of_manufacture}}</p>
            </div>
          </div>
            <div class="d-flex col-12 text-left card-dataprice" >

                <p class="price" *ngIf="element.dealer_suggestive_price != null">{{
                  element.dealer_suggestive_price > 999
                    ? (element.dealer_suggestive_price | currency: 'INR': 'symbol': '4.0-0')
                    : (element.dealer_suggestive_price | currency: 'INR': 'symbol': '1.0-0')
                }}</p><span class="warranty"  *ngIf="element.engine_warranty === 'Yes'">Warranty Available</span>

              <div *ngIf="element.dealer_suggestive_price == null" style="margin-top: 10px;">
               <span style="color:#0A0A5F;">Please contact to dealer</span>
              </div>
            </div>
            <div class="col-12 btngroup">
            <button  class="btn col-6 btn-outline-primary btn-grad-outline-primary btn-brand  " (click)="redirect(element.id)">View Details</button>
            <button id="otpVerification"  class="btn col-6 btn-primary  btn-grad-primary btn-brand " data-bs-toggle="modal" [attr.data-bs-target]="isUserLoggedIn ? '#exampleModaldealer' : '#loginDealer'" (click)="contactDealer(element.id)">Submit Enquiry</button>
            </div>
        </div>
    </div>
    </div>
  </ng-container>
</ng-template>

    <ng-container *ngIf="ParknSell?.length == 0 && productLoaded ">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states">
          <img [src]='environment1 + "assets/images/no_product_found.svg"' loading="lazy">
          <h3>
            No product found
          </h3>
          <div class="desc">
            The product you were looking for couldn’t be found. Explore all <br />
            products to see more commercial vehicles.
          </div>
          <div class="mt-4">
            <button class="btn btn-primary btn-grad-primary btn-brand ps-4 pe-4"
            data-toggle="tooltip" data-placement="top"  title="Click here to Explore all products" (click)="exploreProduct()"
              >Explore all products</button>
          </div>
        </div>
      </ng-container>
</div>

</div>
<div class="productlist mt-3" *ngIf="RecentyViewData">
  <div class="row">
    <ng-container *ngIf="ListingData?.length == 0 && !productLoaded ;else productTemplate">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      *ngFor="let item of skeletonService.generateFake(4);let i = index;">
      <div class="poduct-item">
        <div class="img-wrapper" style="display: block;z-index: 0;">
          <ngx-skeleton height="230px"></ngx-skeleton>
        </div>
        <div class="cv-name text-ellipsis">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
        <div class="price">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
        <div class="rating">
          <ngx-skeleton height="19px"></ngx-skeleton>
        </div>
      </div>
    </div>
      </ng-container>
      <ng-template #productTemplate>
        <ng-container *ngIf="ListingData?.length !== 0 && productLoaded ">
    <div class="col-lg-3 col-md-4 col-sm-12 carddiv" *ngFor="let element of ListingData">
        <div class="card">
            <img (click)="redirect(element.id)" [src]="getiscover(element?.vehicle_documents)" class="card-img-top mainimg" alt="Vehicle Image">
            <div class="d-flex align-items-center tagf">
                <span class="badge bg-primary"><img class="eye" [src]='environment1 + "assets/images/eye.png"' alt=""> {{element?.view_count}} Views </span>
                <div class="like ms-auto d-none">
                  <button style="width: 24px; height: 24px; border: none;background-color: transparent;">
                    <span >
                      <img style="width: 24px; height: 24px;" [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                    </span>
                  </button>
                </div>
              </div>
              <div *ngIf="element.vehicle_certificate_type == 'Certified'">
                <img class="tataoklogobottom" [src]='environment1 + "assets/images/tata-ok.png"' alt="">
                <span class="text-white tataoklogobottomspan">Refurbished</span>
              </div>
            <div class="card-body">
              <div class="card-title text-ellipsis">
                <a  [title]="element?.model">{{element.model}}</a></div>
                <div class="card-data">
                <div class="d-flex col-12 text-left d1 aligndiv">
                  <p class="col-4">State</p>
                  <p class="col-4">District</p>
                    <p class="col-4">Fuel Type</p>
                </div>
                <div class="d-flex col-12 text-left d2 aligndiv d3">
                  <p class="col-4 district pe-1">{{element?.state}}</p>
                  <p class="col-4 district">{{element?.district ? (element?.district  | titlecase) : ''}}</p>
                    <p class="col-4">{{element.fuel_type}}</p>
                </div>
                <div class="d-flex col-12 text-left d1 aligndiv mt-2">
                    <p class="col-4">KMs</p>
                    <p class="col-4">Owner</p>
                    <p class="col-4">Year</p>
                </div>

                <div class="d-flex col-12 text-left d2 aligndiv">
                    <p class="col-4">{{element.odometer ? (element.odometer |  number:'1.0-0') : '' }}</p>
                    <p class="col-4">{{getFirstPartOfOwners(element.no_of_owners)}}</p>
                    <p class="col-4">{{element.year_of_manufacture}}</p>
                </div>
              </div>
              <div class="d-flex col-12 text-left card-dataprice ">

                <p class="price" *ngIf="element.dealer_suggestive_price != null">{{
                  element.dealer_suggestive_price > 999
                    ? (element.dealer_suggestive_price | currency: 'INR': 'symbol': '4.0-0')
                    : (element.dealer_suggestive_price | currency: 'INR': 'symbol': '1.0-0')
                }}</p><span class="warranty"  *ngIf="element.engine_warranty === 'Yes'">Warranty Available</span>

              <div *ngIf="element.dealer_suggestive_price == null" style="margin-top: 10px;">
               <span style="color:#0A0A5F;">Please contact to dealer</span>
              </div>
            </div>
                <div class="col-12 btngroup">
                <button  class="btn col-6 btn-outline-primary btn-grad-outline-primary btn-brand  " (click)="redirect(element.id)">View Details</button>
                <button id="otpVerification"  class="btn col-6 btn-primary  btn-grad-primary btn-brand " data-bs-toggle="modal" [attr.data-bs-target]="isUserLoggedIn ? '#exampleModaldealer' : '#loginDealer'" (click)="contactDealer(element.id)">Submit Enquiry</button>
                </div>
            </div>
        </div>
    </div>
  </ng-container>
</ng-template>
    <ng-container *ngIf="ListingData?.length == 0 && productLoaded ">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states">
          <img [src]='environment1 + "assets/images/no_product_found.svg"' loading="lazy">
          <h3>
            No product found
          </h3>
          <div class="desc">
            The product you were looking for couldn’t be found. Explore all <br />
            products to see more commercial vehicles.
          </div>
          <div class="mt-4">
            <button class="btn btn-primary btn-grad-primary btn-brand ps-4 pe-4"
            data-toggle="tooltip" data-placement="top"  title="Click here to Explore all products" (click)="exploreProduct()"
             >Explore all products</button>
          </div>
        </div>
      </ng-container>
</div>
</div>
</div>
</div>
<!-- Mobile view -->
<div class="offcanvas right-offcanvas offcanvas-start" tabindex="-1" id="offcanvasRight1"
  aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header d-flex align-items-center">
    <span class="me-2" >
      <a href="#" class="stepback"><img class="" id="closeBtnMobile" #closeBtnMobile data-bs-dismiss="offcanvas" aria-label="Close"
          [src]='environment1 + "assets/images/caret-right-black.svg"' loading="lazy" alt="caret-right-black" /></a>
    </span>
    <h5 class="mb-0"></h5>


    <button type="button" id="closeBtnMobile" #closeBtnMobile class="btn-close nav-close text-reset ms-auto"
      data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body d-grid">
    <div class="nav-offcanvas-content">
      <div class="offcanvas-main-nav">
        <ul class="first-nav">
          <li class="item has-sub-menu">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 dropdown-toggle cursor"  data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false" (click)="getTotalMenu('','')">
              <label class="form-label">Select Model</label>
                     <input type="text" class="form-select h-48 search-form-control product-search bannerApplication" [(ngModel)]="filterModel" (input)="filtermodel()" (blur)="getblurmodels()"
                    placeholder="Choose the model to buy"  id="applicationFilter" #applicationFilter />
            </div>
            <div class="dropdown-menu megamenu mobilemenu bannerApplication">
              <div class="px-0">
                <div class="d-flex align-items-start">
                  <div class="nav flex-column nav-pills me-3 mega-vertical-tab mobilediv" id="v-pills-tab" role="tablist"
                       aria-orientation="vertical">
                    <ul class="mobilemodel">
                      <li *ngIf="filteredmodels?.length === 0" >No Data Found</li>
                      <li (mouseenter)="onSubMenuClick('SCVPickups',item.sub_cat_id)" *ngFor="let item of filteredmodels; let i=index">
                        <a class="dropdown-item"

                           class="megatab active" id="{{'tab' + i}}" data-bs-toggle="pill" data-bs-target="#t1"
                           role="tab" aria-controls="#t1" aria-selected="true">
                          {{item.sub_cat_name}}
                          <img alt="caret-right-black" *ngIf="subMenuType == item.sub_cat_id"
                               [src]='environment1 + "assets/images/caret-right-black.svg"'
                               loading="lazy"
                               alt="caret-right-black" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="d-flex align-items-start mt-2">
                  <div class="tab-content mega-vertical-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                      <div class="container-fluid">
                        <div class="row g-3 row-cols-2" style="max-height: 325px; overflow-y: auto;">
                          <div *ngIf="subMenu?.length === 0" >No Data Found</div>
                          <div class="col" *ngFor="let item of subMenu">
                            <a  class="menu-option" (click)="onMenuclick(item)">
                              <div class="menu-img">
                                 <img class="img-fluid subcatimages" loading="lazy" [src]="getdefault(item.name)"  alt="">
                              </div>
                              <div class="menu-title text-center">
                                {{item.name}}
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="item has-sub-menu">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-4 dropdown-toggle cursor"  data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false" (click)="getBudgetMobile()" >
            <label class="form-label">Select Budget</label>
                <input type="text" class="form-select h-48 search-form-control product-search bannerApplication"
                readonly  [(ngModel)]="filterBudget" placeholder="Choose Budget Range" id="applicationFilterbudget" #applicationFilterbudget    />
          </div>
          <div class="dropdown-menu megamenu mobilemenu bannerApplication" >
            <div class="px-0">
              <div class="d-flex align-items-center">
                <div class="row col-12 mt-1">
                  <div class="d-flex justify-content-center">
                </div>
                  <div>
                    <ngx-slider [(value)]="value1" [(highValue)]="highValue1" [options]="options1" (userChangeEnd)="onSliderChange($event)"></ngx-slider>
                  </div>
                  <div class="row col-12">
                  <div class=" col-6">
                    <label class="filter-label">Min Price</label>
                    <div class="minvalue">
                    <input type="text"  (keypress)="onlyNumberKey($event)" [value]="value1" (input)="onMinPriceChange1($event)" class="form-control minvalue" maxlength="10" minlength="1" />
                  </div>
                  </div>
                  <div class="col-6">
                    <label class="filter-label">Max Price</label>
                    <div class="minvalue">
                    <input type="text" (keypress)="onlyNumberKey($event)" [value]="highValue1" (input)="onMaxPriceChange1($event)" class="form-control minvalue " maxlength="10" minlength="1" />
                  </div>
                  </div>
                </div>
                </div>
              </div>

            </div>
          </div>
        </li>
        <li class="item has-sub-menu">

              <div class="nav-link dropdown-toggle cursor" data-bs-toggle="dropdown" data-bs-auto-close="true"
                  aria-expanded="false">
                    <label class="form-label">Select State</label>
                    <input type="text" class="form-select h-48 search-form-control product-search bannerApplication" [(ngModel)]="filterText"
                    (input)="filterstates()" (blur)="getblurstate()"
                    placeholder="Choose State"  id="applicationFilter" #applicationFilter />
                    <div class="dropdown-menu megamenu  bannerApplication" style="width: 92% !important;">
                      <div class="citilist px-0">

                        <ul class=" list-group">
                          <li *ngIf="filteredstates?.length === 0" class="list-group-item">No Data Found</li>
                          <li class="list-group-item list-group-item-action" *ngFor="let elemet of filteredstates" (click)="changestates(elemet)">
                            {{ elemet}}
                          </li>
                        </ul>

                      </div>
                    </div>
                  </div>
        </li>

        </ul>

      </div>

    </div>

    <div class="nav-offcanvas-footer align-self-end">
      <div class="t-c">

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3" style="align-content: center;">
                <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" id="closeBtnMobile" #closeBtnMobile data-bs-dismiss="offcanvas" aria-label="Close" (click)="getFilterdata(0)">Search</button>
              </div>

      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="exampleModaldealer" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modaldiv">
      <div class="modal-header" style="border-bottom: none !important;">
        <h2 *ngIf="!disableForm" class="modal-title fs-5" id="exampleModalLabel">Personal Details</h2>
        <button type="button" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-secondary" style="height: 100% !important;margin-top: 0px;padding-top: 0px;">
        <div *ngIf="!disableForm">
        <form [formGroup]="userForm">
        <div class="col-12">
          <label>Name </label>
              <input   [ngClass]="{
                'disabled': userData?.first_name || userData?.last_name
              }" type="text" class="form-control h-48" formControlName="name" placeholder="Enter Name"
                 (keydown)="notAllowSpace($event)" />
                 <div *ngIf="userForm.controls['name'].invalid && (userForm.controls['name'].dirty || userForm.controls['name'].touched)">
                  <div *ngIf="userForm.controls['name'].errors?.required" class="text-danger">Name is required.</div>
                </div>
        </div>
        <div class="col-12 mt-3">
          <label>Contact Info</label>
          <div class="form-input">
            <div class="country-code">
              <div class="nation-flag">
                <img alt="Nation Flag" [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy"/>
              </div>
              +91
            </div>
            <input formControlName="contact" type="tel"  class="mobile_no"
              maxlength="10" placeholder="Mobile Number" numbersOnly [ngClass]="{
                'disabled': userData?.mobile_number
              }" />

          </div>
          <div *ngIf="userForm.controls['contact'].invalid && (userForm.controls['contact'].dirty || userForm.controls['contact'].touched)">
            <div *ngIf="userForm.controls['contact'].errors?.required" class="text-danger">Contact number is required.</div>
            <div *ngIf="userForm.controls['contact'].errors?.pattern" class="text-danger">Contact number must be 10 digits long.</div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <label>Do you need financing ? </label>
          <div class="mt-3">
            <input id="subscription" type="radio" formControlName="consent" value="yes"> Yes
            <input id="subscription" class="ps-2" type="radio" formControlName="consent" value="no"> No
          </div>
          <div *ngIf="userForm.controls['consent'].invalid && (userForm.controls['consent'].dirty || userForm.controls['consent'].touched)">
            <div *ngIf="userForm.controls['consent'].errors?.required" class="text-danger">consent choice is required.</div>
          </div>
          <div class="form-check mt-2">
            <input class="form-check-input consent-box" type="checkbox" value="" id="defaultCheck1" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)">
            <label class="form-check-label" for="defaultCheck1">
              Consent to allow TATA Motors to contact you
            </label>
          </div>
        </div>
        <div class="col-12 mt-3">
       <button class="btn col-12 btn-primary  btn-grad-primary btn-brand h-48" [disabled]="userForm.invalid" [ngClass]="{'disabled': !checkBoxcheked}" (click)="onSubmit()">Submit</button>
        </div>
      </form>
    </div>
      <div *ngIf="disableForm">
        <div *ngIf="errorMessage?.success">
        <div class="d-flex justify-content-center">
          <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/success.svg"' alt="">
        </div>
        <h2 class="text-center text-dark fw-bold mb-4">Congratulations!</h2>
        <h3 class="text-center text-secondary fw-bold mb-4" style="font-size: larger;">Dealer from TATA Motors will get in touch  with you soon</h3>
        <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Back to Page</button>
      </div>
      <div *ngIf="!errorMessage?.success">
        <div class="d-flex justify-content-center">
          <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/rejected.svg"' alt="">
        </div>
        <h4 class="text-center text-dark fw-bold mb-4">There was some error while submitting.<br>Please try after some time.</h4>
        <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Retry</button>
      </div>
      </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="loginDealer"
  tabindex="-1"
  aria-labelledby="loginDealerLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modaldiv">
      <div class="modal-header " style="border-bottom: none !important">
        <h1
          *ngIf="!disableForm"
          class="modal-title fs-5"
          id="loginDealerLabel"
        >
          Login With OTP
        </h1>
        <button
          type="button"
          id="closeBtn1"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          aria-hidden="true"
        ></button>
      </div>
      <div
        class="modal-body text-secondary"
        style="height: 100% !important; margin-top: 0px; padding-top: 0px"
      >
        <div *ngIf="!disableForm">
          <form [formGroup]="userLoginForm">
            <div class="col-12 mt-3">
              <label for="mobileNumber">Contact Info</label>
              <div class="form-input">
                <div class="country-code">
                  <div class="nation-flag">
                    <img
                      alt="Nation Flag"
                      [src]='environment1 + "assets/images/ind-flag.svg"'
                      class="img-fluid"
                      loading="lazy"
                    />
                  </div>
                  +91
                </div>
                <input
                  id="mobileNumber"
                  formControlName="mobile_number"
                  type="tel"
                  class="mobile_no"
                  maxlength="10"
                  placeholder="Mobile Number"
                  numbersOnly
                  (keypress)="onlyNumberKey($event)"
                  [ngClass]="{
                    'disabled': userData?.mobile_number
                  }"
                />
              </div>
              <div
                *ngIf="userLoginForm.controls['mobile_number'].invalid && (userLoginForm.controls['mobile_number'].dirty || userLoginForm.controls['mobile_number'].touched)"
              >
                <div
                  *ngIf="userLoginForm.controls['mobile_number'].errors?.required"
                  class="text-danger"
                >
                  Contact number is required.
                </div>
                <div
                  *ngIf="userLoginForm.controls['mobile_number'].errors?.pattern"
                  class="text-danger"
                >
                  Contact number must be 10 digits long.
                </div>
              </div>
              <div class="form-check mt-2">
                <input
                  class="form-check-input consent-box"
                  type="checkbox"
                  id="defaultCheck1" [formControl]="checkBoxControl"
                  #myCheckbox
                  (change)="onCheckboxChange(myCheckbox.checked)"
                />
                <label class="form-check-label" for="defaultCheck1">
                  Consent to allow TATA Motors to contact you
                </label>
              </div>
            </div>
            <div class="col-12 mt-3">
              <button
                class="btn col-6 btn-primary btn-grad-primary btn-brand"
                data-bs-toggle="modal"
                [disabled]="userLoginForm.invalid" 
                [ngClass]="{'disabled': !checkBoxcheked}"
                data-bs-target="#showOtp"
                (click)="sentOtp()"
              >
                GET CODE
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



<div
  class="modal fade"
  id="showOtp"
  tabindex="-1"
  aria-labelledby="showOtpLabel"
  aria-hidden="true" 
  [hidden]="!(isshowOtp || isshowSignUp)"
>
  <div class="modal-dialog modal-dialog-centered">
  <div class="modal-content modaldiv" >
      <div class="close-button" style="border-bottom: none !important">
        <button
          type="button"
          id="closeBtn2"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body text-secondary"
        style="height: 100% !important; margin-top: 0px; padding-top: 0px"
      >
      <section *ngIf="isshowOtp">
        <app-otp (loadParent)="showLogin()"  (loadSignup)="showSignup()"></app-otp>
      </section>
      <section *ngIf="isshowSignUp">
        <app-signup (loadParent)="showLogin()" (loadOtpParent)="showOtp()"></app-signup>
      </section>
      </div>
    </div>
    
  </div>
</div>
